import { Link } from 'react-router-dom';
import { PageFrame } from '../components/PageFrame';

export function NotFoundPage() {
  return (
    <PageFrame>
      <section className="not-found section-shell">
        <p className="eyebrow">404</p>
        <h1>This thought wandered off.</h1>
        <p>The page you were looking for is not here.</p>
        <Link className="button button--ink" to="/">Return home</Link>
      </section>
    </PageFrame>
  );
}
